import { render, staticRenderFns } from "./PaymentDetailForm.vue?vue&type=template&id=4952e037&scoped=true&"
import script from "./PaymentDetailForm.vue?vue&type=script&lang=js&"
export * from "./PaymentDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetailForm.vue?vue&type=style&index=0&id=4952e037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952e037",
  null
  
)

export default component.exports